import { render, staticRenderFns } from "./Provincialdowntownstreet.vue?vue&type=template&id=2e507de9&scoped=true&"
import script from "./Provincialdowntownstreet.vue?vue&type=script&lang=js&"
export * from "./Provincialdowntownstreet.vue?vue&type=script&lang=js&"
import style0 from "./Provincialdowntownstreet.vue?vue&type=style&index=0&id=2e507de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e507de9",
  null
  
)

export default component.exports